import styled from 'styled-components';

export const Title = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;

  b {
    font-size: 20px;
  }
`;

export const Message = styled.span`
  text-decoration: underline;
  display: block;
  cursor: pointer;
  overflow-wrap: break-word;
  word-break: break-word;
`;

export const ActionsButtons = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .ant-btn {
    width: 100%;
    white-space: normal;
    height: auto;
    min-height: 32px;
  }
`;
